// Add-menu store — попап выбора типа добавляемого материала (Загрузить / Записать).
// Открывается кнопкой «+» в шапке; из него пользователь переходит либо в
// UploadDialog (useUploadDialogStore), либо на экран записи лекции (/recordings/new).
// Не персистится: при перезагрузке всегда закрыт.
import { create } from "zustand";

interface AddMenuStore {
	isOpen: boolean;
	open: () => void;
	close: () => void;
	setOpen: (open: boolean) => void;
}

export const useAddMenuStore = create<AddMenuStore>((set) => ({
	isOpen: false,
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
	setOpen: (open) => set({ isOpen: open }),
}));
